import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

export default function(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy,
        items: this.signMethodOptions,
        label: this.getTranslate(`${Services.contracts}.labels.signMethod`),
        labelMode: this.labelMode,
        disabled: !this.canSetSignMethod,
        defaultValue: null,
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
